import { HTMLAttributes, ReactNode } from 'react'
import './InputErrorWrapper.css'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface InputErrorWrapperProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    showErrorMessage?: boolean
    errorMessage?: string
    id: string
    className: string
}

function InputErrorWrapper({ children, showErrorMessage, errorMessage, id, className}: InputErrorWrapperProps) {

    
 return (
    <div className={`input-error-container form-input ${className}`} id={id} >
        {children}
        {showErrorMessage && <span className='error-message'><FontAwesomeIcon icon={faCircleExclamation} className='circle-exclamation'/><p className='error-message-text'>{errorMessage}</p></span>}
    </div>
 )
}

export default InputErrorWrapper